/* ============================================================
   ATELIER HAÏYA — main.js (Shopify)

   Initialisation globale :
   - Gestion des erreurs d'image
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {
  initImageFallbacks();
});

/* ----------------------------------------------------------
   Fallback images cassées
   ---------------------------------------------------------- */

function initImageFallbacks() {
  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('error', () => {
      img.style.visibility = 'hidden';
    });
  });
}
